import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {FormGroup, Icon, useForm, Yup} from '../components';
import styled from "styled-components";
import Select from "../forms/inputs/Select";
import {COLORS} from '../theme';
import VendorForm from "./VendorForm";
import IabLogo from "../../../assets/images/layout4/iab-logo.png";
import GoogleLogo from '../../../assets/images/layout4/logo_google_g_icon.png'

const Separator = styled.div`
  text-align: center;
  position: relative;
  margin: 20px 0;
  &:after {
    content: "";
    height: 1px;
    width: 50%;
    position: absolute;
    top: 50%;
    left: 25%;
    background-color: silver;
    z-index: 0;
  }
  span {
    position: relative;
    z-index: 1;
    background-color: ${COLORS.lightGrey};
    padding: 0 4px;
  }
`

export const VendorAddModal = ({show,
                                 setShow,
                                 availableVendors,
                                 getAvailableVendors,
                                 onCreate,
                                 addVendor,
                                 vendorFormProps,
                                 isAvailableVendorsLoading,
                                 params,
                                 setActiveKey}) => {
  const handleClose = (vendor) => {
    setShow(false);
    let activeKey;
    if (vendor) {
      if (vendor.iabId) {
        activeKey = "iab"
      } else if (vendor.googleId) {
        activeKey = "google"
      } else {
        activeKey = "custom"
      }
      setActiveKey(activeKey)
    }
  }
  const { t } = useTranslation();
  const [showCreateVendor, setShowCreateVendor] = useState(false)
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  useEffect(() => {
    show && getAvailableVendors(params, true)
  }, [show])


  return (
    <>
      <Modal show={show} onHide={handleClose} size={"lg"}>
        <Modal.Header closeButton>
          <Modal.Title>{t("cmp.vendors.addVendor")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showCreateVendor && <VendorForm
            setSubmitButtonProps={setSubmitButtonProps}
            onSubmit={onCreate}
            {...vendorFormProps}/>}
          {!showCreateVendor && <>
            <AddExistingVendorForm
              setSubmitButtonProps={setSubmitButtonProps}
              availableVendors={availableVendors}
              addVendor={addVendor}
              params={params}
              handleSuccess={handleClose}
              isLoading={isAvailableVendorsLoading}/>
            <Separator><span>{t("or")}</span></Separator>
            <Row>
              <Col style={{textAlign: 'center'}}>
                <Button onClick={() => setShowCreateVendor(true)}>{t("cmp.vendors.createVendor")}</Button>
              </Col>
            </Row>
          </>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' key="cancel" onClick={handleClose}>
            <Icon icon='cancel' text={t("cancel")} />
          </Button>
          <Button key="submit" type="submit" variant="primary" {...submitButtonProps}>
            <Icon icon='save' text={t("save")} />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function AddExistingVendorForm({setSubmitButtonProps, availableVendors, addVendor, params, handleSuccess, isLoading}) {
  const { t } = useTranslation();

  const initialValues = {
    vendorId: ''
  };
  const validationSchema = Yup.object().shape({
    vendorId: Yup.number().required()
  })

  const { getInputProps, formProps } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    setSubmitButtonProps: setSubmitButtonProps,
    onSubmit: (data) => {
      addVendor({...params, vendorId: data.vendorId}).unwrap().then(handleSuccess)
    },
  });

  function VendorLogo({vendor}) {
    const style = {
      width: "20px",
      marginRight: "4px"
    }
    if (vendor.iabId) {
      return <img src={IabLogo} style={style}/>

    } else if (vendor.googleId) {
      return <img src={GoogleLogo} style={style}/>
    } else {
      return <span style={style}/>
    }
  }

  return <Form {...formProps}>
    <FormGroup label={t("cmp.vendors.selectVendor")} {...getInputProps("vendorId")} placeholder={t("pleaseSelect")}>
      <Select options={availableVendors.map( vendor => ({value: vendor.id, label: vendor.name, iabId: vendor.iabId, googleId: vendor.googleId}))}
              formatOptionLabel={vendor => <><VendorLogo vendor={vendor}/><span>{vendor.label}</span></>}
              isLoading={isLoading}/>
    </FormGroup>
  </Form>
}
